var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplay)?_c('a',{attrs:{"href":_vm.imageLink}},[_c('img',{staticClass:"column is-results-ad",attrs:{"id":_vm.uniqueId,"src":_vm.imageSrc,"alt":"advertisement"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }